import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './ScrollableArea.module.css';

const bindClasses = classNameBind.bind(styles);

class ScrollableArea extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.calculateShadow(this.ref);
  }

  componentDidUpdate() {
    const { width } = this.state;
    if (width !== this.ref.scrollWidth) {
      this.calculateShadow(this.ref);
    }
  }

  calculateShadow = (target) => {
    if (typeof (target) !== 'undefined') {
      this.setState({
        leftShadow: !!target.scrollLeft,
        topShadow: !!target.scrollTop,
        rightShadow: target.scrollLeft < (target.scrollWidth - target.clientWidth),
        bottomShadow: target.scrollTop < (target.scrollHeight - target.clientHeight),
        width: target.scrollWidth,
      });
    }
  }

  render() {
    const {
      leftShadow,
      rightShadow,
      topShadow,
      bottomShadow,
    } = this.state;
    const { height, orientation, children } = this.props;

    return (
      <div
        className={bindClasses('wrapper')}
        data-ppuc-id="ScrollableArea"
      >
        <div
          className={bindClasses('wrapper-inside', height, orientation, { leftShadow, rightShadow, topShadow, bottomShadow })}
          ref={(r) => { this.ref = r; }}
          onScroll={(e) => { this.calculateShadow(e.target); }}
        >
          <div>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

ScrollableArea.defaultProps = {
  children: null,
  height: '',
  orientation: 'horizontal',
};

export default ScrollableArea;
